import './ChatPage.scss'

import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { api, streamPost } from '../../utils/api';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';

export default function ChatPage() {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const bottomRef = useRef(null);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await api.get(`/messages`);
        setMessages(response.data);
      } catch (err) {
        console.log('error');
      }
    };
    fetchMessages();
  }, []);

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async () => {
    if (!message.trim()) return;

    const userMessage = { id: Date.now(), content: message, sender: 'human' };
    setMessages(prev => [...prev, userMessage]);
    setMessage('');

    const botMessage = { id: Date.now() + 1, content: '', sender: 'assistant' };
    setMessages(prev => [...prev, botMessage]);

    const updateBotMessage = (newContent) => {
      setMessages(prev => {
        const updated = [...prev];
        const botIndex = updated.findIndex(m => m.id === botMessage.id);
        if (botIndex !== -1) {
          updated[botIndex] = { ...updated[botIndex], content: newContent };
        }
        return updated;
      });
    };

    try {
      const reader = await streamPost(`/messages/stream`, { content: userMessage.content });
      const decoder = new TextDecoder();
      let done = false;
      let accumulated = '';

      while (!done) {
        const { value, done: doneReading } = await reader.read();
        done = doneReading;

        if (value) {
          const chunk = decoder.decode(value, { stream: true });
          accumulated += chunk;
          updateBotMessage(accumulated);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className='__chat'>
      <div className='header'>
        <Link to="/"><img className='group' src="/images/logo.png" alt="Papaya Logo" /></Link>
      </div>

      <div className='content'>
        <div className='welcome'>Ask Papaya!</div>
        
        <div className='messages'>
          {messages.map((message, index) => (
            <div key={index} className={classNames('message', message.sender)}>
              <ReactMarkdown>{message.content}</ReactMarkdown>
            </div>
          ))}
        </div>
        <div ref={bottomRef} />
      </div>

      <div className='send-menu'>
        <textarea
          type="text"
          placeholder="Ask Anything"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
        />
        <button className='send' onClick={handleSendMessage}>
          Send
        </button>
      </div>
    </div>
  );
}